import React from 'react';
import c from 'classnames';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import DiscordIcon from '@wix/da-ds/pkg/Icons/16x16/Discord';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './Benefit.scss';
const Benefit = ({ benefit, isDiscord, className })=>/*#__PURE__*/ React.createElement(Flex, {
        className: c(s['root'], className),
        alignItems: "flex-start"
    }, isDiscord ? /*#__PURE__*/ React.createElement(DiscordIcon, {
        className: c(s['icon'], s['icon-discord']),
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }) : /*#__PURE__*/ React.createElement(CheckIcon, {
        className: c(s['icon'], s['icon-check']),
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", null, benefit));
Benefit.displayName = 'Benefit';
export default Benefit;

//# sourceMappingURL=Benefit.js.map